import {useQuery} from "@tanstack/react-query";
import {getBusinessCardFieldCheckStatus} from "@sakura-grp/database/services";
import {getBrowserClient} from "@/lib/supabase";

export function useBusinessCardFieldChecks(ids: readonly string[]) {
  const sortedIds = [...new Set(ids.map(String))].sort();
  return useQuery({
    queryKey: ["business-card-field-checks", sortedIds],
    queryFn: () => getBusinessCardFieldCheckStatus(getBrowserClient(), sortedIds),
    enabled: sortedIds.length > 0,
  });
}
